export { default } from './upload-compliance-letter';
